import RoutesPage from "../routes";

export default function FavoriteRoutesPage() {
    return <RoutesPage initialFilter="favorites" />;
}
